import React, { useEffect } from "react";
import { DataContext } from "../../../store/DataContext";
import Item from "./item/NavigationItem";
import styles from "./NavigationItems.module.css";

const NavigationItems = (props) => {
	useEffect(() => {}, [props.navigation.active]);

	const items = props.navigation.data.map((k, i) => {
		let booled = false;
		if (props.navigation.active === k.name) {
			booled = true;
		}

		return (
			<Item
				key={k.name + i}
				link={k.name}
				clicked={() => {
					props.changeActiveNavElement(k.name);
					if (props.toggleHandler) props.toggleHandler();
					if (k.clicked) k.clicked();
				}}
				current={booled}
			>
				{k.name}
			</Item>
		);
	});

	return <ul className={styles.NavigationItems}>{items}</ul>;
};

export default (props) => (
	<DataContext.Consumer>
		{(mainConsumer) => <NavigationItems {...mainConsumer} {...props} />}
	</DataContext.Consumer>
);
